import KeyLine from 'components/shared/KeyLine';
import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { Colorways, Margins } from 'types/constants';
import { cn, getColorway, getRoundedCornersBox, getYMargins } from 'utils/styles';
import CanvasNavItem from './CanvasNavItem';
import { CanvasNavProps } from './types';

const CanvasNav = ({ sys, headline, canvasNavItems, roundedCorners, sectionName, footerColor }: CanvasNavProps) => {
  const items = canvasNavItems?.items ?? [];

  if (!items.length) return null;

  return (
    <section
      {...(sectionName != null && { id: encodeURIComponent(sectionName) })}
      className={cn(
        // The module always sits above the footer and inherits the footer colorway
        getColorway(footerColor ?? Colorways.Primary),
        // Optionally round the top corners into the section above (Top or None only)
        getRoundedCornersBox(roundedCorners),
        // The keyline always sits flush at the module's bottom edge
        getYMargins(Margins.NoBottom),
        sectionName && 'scroll-mt-[var(--height-nav)]',
      )}>
      <div className="content-wrapper flex flex-col gap-12 md:gap-20">
        {headline && (
          <div className="font-sans text-heading-md sm:text-heading-lg-fixed" {...liveUpdateAttrs(sys?.id, 'headline')}>
            <RichTextHeadline headline={headline} level="h2" />
          </div>
        )}
        <ul
          className={cn(
            // Mobile: Stacked
            'flex flex-col items-start gap-8',
            // Tablet: Items overflow container and can be scrolled horizontally
            'sm:flex-row sm:gap-6 sm:overflow-x-auto sm:-mx-10 sm:px-10 sm:no-scrollbar',
            // Desktop: Items fit container
            'lg:-mx-14 lg:px-14',
          )}
          {...liveUpdateAttrs(sys?.id, 'canvasNavItems')}>
          {items.map((item, index) => (
            <CanvasNavItem key={`${item.sys?.id ?? 'item'}-${index}`} item={item} />
          ))}
        </ul>
        <KeyLine />
      </div>
    </section>
  );
};

export default CanvasNav;
